import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(0.5)
        }
    }
}));

export default props => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    return (
        <div className={classes.root}>
            <Chip
                size="small"
                style={{ backgroundColor: "#90EAB7", color: "#fff", fontFamily: "Lato" }}
                label="Pro "
                onClick={() => setOpen(true)}
            />
            <Dialog onClose={value => setOpen(false)} aria-labelledby="simple-dialog-title" open={open}>
                <DialogTitle id="simple-dialog-title">Kan kun benyttes med Pro version</DialogTitle>
            </Dialog>
        </div>
    );
};
